var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffordable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 9.5625H6.375C4.61459 9.5625 3.1875 10.9896 3.1875 12.75V25.5C3.1875 27.2604 4.61459 28.6875 6.375 28.6875H27.625C29.3854 28.6875 30.8125 27.2604 30.8125 25.5V12.75C30.8125 10.9896 29.3854 9.5625 27.625 9.5625Z",
    stroke: "#F98700",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3169 9.56241V7.57022C27.3167 7.08161 27.2087 6.59905 27.0006 6.15698C26.7925 5.71491 26.4893 5.32423 26.1128 5.0128C25.7363 4.70137 25.2957 4.47688 24.8225 4.35534C24.3492 4.2338 23.855 4.21821 23.375 4.30967L5.88625 7.29463C5.12678 7.43937 4.44162 7.8446 3.94895 8.44043C3.45627 9.03627 3.18698 9.78536 3.1875 10.5585V13.8124",
    stroke: "#F98700",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 21.25C24.0172 21.25 23.6064 21.1254 23.2569 20.8919C22.9075 20.6584 22.6351 20.3265 22.4743 19.9382C22.3134 19.5499 22.2713 19.1226 22.3533 18.7104C22.4353 18.2982 22.6377 17.9196 22.9349 17.6224C23.2321 17.3252 23.6107 17.1228 24.0229 17.0408C24.4351 16.9588 24.8624 17.0009 25.2507 17.1618C25.639 17.3226 25.9709 17.595 26.2044 17.9444C26.4379 18.2939 26.5625 18.7047 26.5625 19.125C26.5625 19.6886 26.3386 20.2291 25.9401 20.6276C25.5416 21.0261 25.0011 21.25 24.4375 21.25Z",
    fill: "#F98700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordable);
export default __webpack_public_path__ + "static/media/affordable.3051f7e4b06bcae43d439901c0a350c3.svg";
export { ForwardRef as ReactComponent };